import { type FC } from "react";

import { type AvatarProps, AvatarWithLabel } from "../MomentAvatar";

export const UserAvatarAlpha: FC<AvatarProps> = (props) => {
	return <AvatarWithLabel {...props} />;
};
